import { bodyShadowX } from './BodyShadowStore';

export const updateBodyShadowX = (value) => bodyShadowX.update(oldValue => value);
